/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import icon from 'flarum/common/helpers/icon';
import app from 'flarum/forum/app';
import { slug } from '../../common';
import Banner from './banner/Banner';

const t = app.translator.trans.bind(app.translator);

export default class BannerListItem extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { banner } = this.attrs;

		const isActive = banner.hasStarted() && !banner.hasEnded();
		// TODO : active badge/border... ?

		const position = t(`${slug}.forum.compose.${banner.setup().position}`);

		return (
			<div
				className={`BannerListItem ${isActive ? 'isActive' : ''} ${banner.setup().position}`}
				onclick={() => m.route.set(app.route('compose-banner', { edit: banner.id() }))}
			>
				<Banner banner={banner} />
				<div className="BannerListItem-infos">
					<div className="Banner-position BannerListItem-info">
						<div>{icon('fas fa-crosshairs')}</div>
						<div>{position}</div>
					</div>
					<div className="BannerListItem-dates">
						<div className="BannerListItem-info">
							<div>{icon('fas fa-calendar-alt')}</div>
							<div>{dayjs(banner.setup().start_date).format('MMM D, YYYY HH:mm')}</div>
						</div>
						{icon('far fa-arrow-to-right')}
						<div className="BannerListItem-info">
							<div>{icon('fas fa-calendar-alt')}</div>
							<div>{dayjs(banner.setup().end_date).format('MMM D, YYYY HH:mm')}</div>
						</div>
					</div>
				</div>

				<div className="BannerListItem-actions">
					<Button className="Button Button--icon" icon="far fa-edit"></Button>
				</div>
			</div>
		);
	}
}
